import React from 'react'

export default function ScreenSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
      <path d="M0 1.79016C0 1.35377 0.364248 1 0.79344 1H15.2066C15.6448 1 16 1.35102 16 1.79016V12.8414C16 13.2778 15.6358 13.6316 15.2066 13.6316H0.79344C0.35524 13.6316 0 13.2806 0 12.8414V1.79016ZM1.6 2.57895V12.0526H14.4V2.57895H1.6ZM2.4 14.4211H13.6V16H2.4V14.4211Z" fill="currentColor" />
    </svg>
  )
}